class r {
  succeeded;
  error;
  constructor(e, s) {
    this.succeeded = e, this.error = s;
  }
  static failure(e) {
    return new r(!1, e);
  }
  static success() {
    return new r(!0, void 0);
  }
}
export {
  r as ValidationResult
};
//# sourceMappingURL=index4.js.map
